export const GET_CONSOLE_USER_REQUEST = '[CONSOLE_USERS] GET_CONSOLE_USER_REQUEST'
export const GET_CONSOLE_USER_SUCCESS = '[CONSOLE_USERS] GET_CONSOLE_USER_SUCCESS'
export const GET_CONSOLE_USER_FAILED = '[CONSOLE_USERS] GET_CONSOLE_USER_FAILED'

export const GET_CONSOLE_USER_LIST_REQUEST = '[CONSOLE_USERS] GET_CONSOLE_USER_LIST_REQUEST'
export const GET_CONSOLE_USER_LIST_SUCCESS = '[CONSOLE_USERS] GET_CONSOLE_USER_LIST_SUCCESS'
export const GET_CONSOLE_USER_LIST_FAILED = '[CONSOLE_USERS] GET_CONSOLE_USER_LIST_FAILED'

export const CREATE_CONSOLE_USER_REQUEST = '[CONSOLE_USERS] CREATE_CONSOLE_USER_REQUEST'
export const CREATE_CONSOLE_USER_SUCCESS = '[CONSOLE_USERS] CREATE_CONSOLE_USER_SUCCESS'
export const CREATE_CONSOLE_USER_FAILED = '[CONSOLE_USERS] CREATE_CONSOLE_USER_FAILED'

export const EDIT_CONSOLE_USER_REQUEST = '[CONSOLE_USERS] EDIT_CONSOLE_USER_REQUEST'
export const EDIT_CONSOLE_USER_SUCCESS = '[CONSOLE_USERS] EDIT_CONSOLE_USER_SUCCESS'
export const EDIT_CONSOLE_USER_FAILED = '[CONSOLE_USERS] EDIT_CONSOLE_USER_FAILED'

export const DELETE_CONSOLE_USER_REQUEST = '[CONSOLE_USERS] DELETE_CONSOLE_USER_REQUEST'
export const DELETE_CONSOLE_USER_SUCCESS = '[CONSOLE_USERS] DELETE_CONSOLE_USER_SUCCESS'
export const DELETE_CONSOLE_USER_FAILED = '[CONSOLE_USERS] DELETE_CONSOLE_USER_FAILED'

export const CONSOLE_USER_SEARCH_REQUEST = '[CONSOLE_USERS] CONSOLE_USER_SEARCH_REQUEST'
export const CONSOLE_USER_SEARCH_SUCCESS = '[CONSOLE_USERS] CONSOLE_USER_SEARCH_SUCCESS'
export const CONSOLE_USER_SEARCH_FAILED = '[CONSOLE_USERS] CONSOLE_USER_SEARCH_FAILED'

export const RESET_CONSOLE_USER_FORM = '[CONSOLE_USERS] RESET_CONSOLE_USER_FORM';




